import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, lifecycle, withProps } from 'recompose';
import { products as productsAPI } from 'api';
import reducers, { getIsFetching, getProducts } from './reducers';
import { resetProductsListApiHOC } from './actions';

const ProductsListApiHOC = ({ getFilters } = { }) => WrappedComponent => compose(
  connect(
    state => ({
      _productsListApiHOC_state: {
        products: getProducts(state),
        isProductsListFetching: getIsFetching(state),
      },
    }),

    dispatch => ({
      _productsListApiHOC_actions: {
        getProducts: bindActionCreators(productsAPI.actions.getProducts, dispatch),
        resetProductsList: bindActionCreators(resetProductsListApiHOC, dispatch),
      },
    }),
  ),

  /* eslint-disable no-underscore-dangle */
  withProps(
    props => ({
      productsListApiHOC: {
        ...props._productsListApiHOC_state,
        ...props._productsListApiHOC_actions,
      },
    }),
  ),
  /* eslint-enable no-underscore-dangle */

  lifecycle({
    componentDidMount() {
      if (getFilters) {
        this.props.productsListApiHOC.getProducts({ filters: getFilters(this.props) });
      } else {
        this.props.productsListApiHOC.getProducts({ filters: {} });
      }
    },
  }),
)(WrappedComponent);

export { reducers };

export default ProductsListApiHOC;



// WEBPACK FOOTER //
// ./src/components/apiHOCs/ProductsListApiHOC/index.js